import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Landing from '../Esg/Landing';
import { FaAngleRight } from "react-icons/fa6";

const caseStudies = [
    {
        title: "Bill Walsh leadership lessons",
        description: "Like to know the secrets of transforming a 2-14 team into a 3x Super Bowl winning....",
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=2070&auto=format&fit=crop", // placeholder or use project asset
        link: "/case-studies/bill-walsh"
    },
    {
        title: "Bill Walsh leadership lessons",
        description: "Like to know the secrets of transforming a 2-14 team into a 3x Super Bowl winning....",
        image: "https://images.unsplash.com/photo-1542744173-8e7e5381a36e?q=80&w=2070&auto=format&fit=crop",
        link: "/case-studies/bill-walsh"
    },
    {
        title: "Bill Walsh leadership lessons",
        description: "Like to know the secrets of transforming a 2-14 team into a 3x Super Bowl winning....",
        image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=2070&auto=format&fit=crop",
        link: "/case-studies/bill-walsh"
    },
    {
        title: "Bill Walsh leadership lessons",
        description: "Like to know the secrets of transforming a 2-14 team into a 3x Super Bowl winning....",
        image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=2070&auto=format&fit=crop",
        link: "/case-studies/bill-walsh"
    }
];

const CaseStudyCard = ({ item }) => {
    return (
        <div className="flex flex-col bg-white rounded-2xl shadow-[0_4px_25px_0_rgba(0,0,0,0.1)] overflow-hidden hover:shadow-[0_8px_35px_0_rgba(0,0,0,0.15)] transition-all duration-300 group h-full">
            <div className="relative h-56 w-full overflow-hidden">
                <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
            </div>
            <div className="flex flex-col p-6 gap-4 flex-grow">
                <h3 className="text-xl font-bold text-black group-hover:text-[#1C486B] transition-colors line-clamp-2">
                    {item.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed line-clamp-3">
                    {item.description}
                </p>
                <div className="mt-auto pt-4 flex items-center text-[#1C486B] font-bold text-sm gap-2 cursor-pointer hover:underline">
                    View Case Study <FaAngleRight className="text-xs" />
                </div>
            </div>
        </div>
    );
};

const CaseStudies = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <Helmet>
                <title>Case Studies | ESG Success Stories & Impact | Nirantara</title>
                <meta name="description" content="Discover how Nirantara helps organizations achieve their ESG and sustainability goals through real-world case studies and success stories." />
                <link rel="canonical" href="https://nirantara.solutions/case-studies" />
            </Helmet>

            <div className="flex flex-col items-center w-full montserrat">
                <Landing
                    text={"CASE\nSTUDIES"}
                    isMobile={isMobile}
                    image="/casestudies.jpg"
                />

                <div className="flex flex-col items-center w-full gap-10 sm:gap-14 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem] montserrat bg-[#FFF]">
                    <div className="w-full">
                        <h2 className="text-3xl font-bold text-black mb-10 uppercase tracking-tight">CASE STUDIES</h2>

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                            {caseStudies.map((item, index) => (
                                <CaseStudyCard key={index} item={item} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CaseStudies;
